<template lang="pug">
  .panel.panel-default
    loading(v-if="isLoading")
    //- 交換者の交換情報一覧
    exchanger-list(
      v-else-if="list.length > 0",
      v-model="list",
      :pCheckedIds="checkedIds",
      :sort="currParams.sort",
      :itemLocation="itemLocation",
      @checkAll="checkAll",
      @checkItem="checkItem",
      @clickUser="showProfile"
    )
      template(v-if="isExchanged", slot="thLast")
        th.bcard-table-th-btn
      template(v-if="isExchanged", slot="tdLast", slot-scope="{item}")
        td.bcard-table-td-btn
          func-del-exchange.btn-xs(v-if="isDeletable(item)", :sid-person="sidPerson", @success="onDelete")

    .panel-body.text-center(v-else) 交換者情報はありません。

    portal(to="modal")
      modal-profile(v-model="modalProfile")
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import mixinList from '@/mixins/innerList'
import Loading from '@/components/molecules/Loading'
import ExchangerList from '@/components/organisms/lists/ExchangerList'
import ModalProfile from '@/components/organisms/ModalProfile'
import RepositoryFactory from '@/repositories/RepositoryFactory'
import FuncDelExchange from '@/components/organisms/functions/FuncDelExchange'

const PersonRepository = RepositoryFactory.get('person')
// const ExchangeRepository = RepositoryFactory.get('exchange')

export default {
  name: 'CardTabExchangerList',
  components: {
    AppModal,
    Loading,
    ExchangerList,
    ModalProfile,
    FuncDelExchange
  },
  mixins: [ mixinList ],
  props: {
    sidPerson: { type: [String, Number], required: true },
    /**
     * @param {Object} POST /bcards のレスポンスのうち1件またはGET /persons/overview
     */
    value: { type: Object, required: true }
  },
  data () {
    return {
      isLoading: true,

      // ソート項目リスト
      // sortOptions: [
      //   {'label': '氏名', 'sort_item': 'name'},
      //   {'label': '部署名', 'sort_item': 'dept'},
      //   {'label': '役職', 'sort_item': 'post'},
      //   {'label': '初回名刺交換日', 'sort_item': 'first_exchange_date'},
      //   {'label': '最終名刺交換日', 'sort_item': 'last_exchange_date'}
      // ],

      // 初期条件
      initParams: {
        // ページ条件
        page: {page: 1},
        // ソート条件
        sort: { sort_item: 'last_exchange_date', direction: 'desc' },
        // 検索条件
        conds: {}
      },
      // 現在の条件
      currParams: {
        // ページ条件
        page: {page: 1},
        // ソート条件
        sort: { sort_item: 'last_exchange_date', direction: 'desc' },
        // 検索条件
        conds: {}
      },

      modalProfile: {
        isOpen: false,
        userId: null
      }
    }
  },
  computed: {
    /**
     * 1回でも交換したことがあるかどうか
     */
    isExchanged () {
      return this.value.isExchanged
    }
  },
  watch: {
    // storeのwatchの仕方は他にもある
    // https://stackoverflow.com/questions/43270159/vuejs-2-how-to-watch-store-values-from-vuex
    '$store.state.base.bcardListReloader' (bcardListReloader) {
      if (bcardListReloader) {
        this.getList(this.currParams)
      }
    },
    sidPerson (id) {
      this.getList(this.currParams)
    }
  },
  created () {
    this.getList(this.initParams)
  },
  methods: {
    getList (options) {
      const id = this.sidPerson
      if (!id) return

      // options = options || {}
      //
      // let page = options.page || this.currParams.page
      // let sort = options.sort || this.currParams.sort
      // let conds = options.conds || this.currParams.conds

      const vm = this

      this.clearErrorMessages()
      this.isLoading = true

      // API実行
      PersonRepository.getExchangers(id, this.isMgmt)
        .then(function (response) {
          const data = vm.getApiData(response)
          vm.list = data.data
          // vm.pagination = data.pagination
          // vm.informationCount = vm.pagination.count

          // 全件削除後に一覧再取得した場合など、交換者が0人だった場合、名刺人物はもう存在しない
          if (vm.list.length === 0) {
            vm.$emit('delete')
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '交換者情報を取得できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
        .finally(function () {
          vm.isLoading = false
        })
    },
    /**
     *  プロフィールダイアログを表示する
     */
    showProfile (item) {
      this.modalProfile.userId = item.id
      this.modalProfile.isOpen = true
    },
    /**
     * クリックしたユーザーの交換履歴を表示する
     * @param item
     */
    itemLocation (item) {
      return {
        name: 'box-exchanger-exchanges',
        params: {
          sidPerson: this.sidPerson,
          sidUser: item.id,
          item
        }
      }
    },
    isDeletable (item) {
      // 所有者（ログインユーザーIDを使って自分の名刺を一括で削除するので、機能管理者モードでは使えない）
      return item.id === this.$store.getState('login_user').id
    },
    onDelete () {
      if (this.list.length > 1) {
        this.$emit('reload')
        this.getList()
      }
      else {
        // ほかに交換者がいない場合、名刺人物はもう存在しない
        this.$emit('delete')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/box/CardTabExchangerList.vue